import { useMutation } from "react-query";
import http from "infra/http";
import { EncomendaStatusEnum } from "core/features/encomenda/typings";

function useProgredirStatus() {
  return useMutation(
    `/v1/encomenda/progredir-status`,
    async ({
      id,
      proximoStatusId,
    }: {
      id: string;
      proximoStatusId?: EncomendaStatusEnum;
    }) => {
      const { data } = await http.post<{ success: boolean }>(
        `/v1/encomenda/${id}/progredir-status`,
        proximoStatusId
          ? {
              proximoStatusId,
            }
          : undefined
      );

      return data;
    },
    { retry: false }
  );
}

export default useProgredirStatus;
